import script from "./KendouTechniquePage.vue?vue&type=script&setup=true&lang=js"
export * from "./KendouTechniquePage.vue?vue&type=script&setup=true&lang=js"

import "./KendouTechniquePage.vue?vue&type=style&index=0&id=1ba0f4ff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ba0f4ff"]])

export default __exports__